var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "badge",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.197,
    height: 16.197,
    viewBox: "0 0 16.197 16.197",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2596",
    "data-name": "Path 2596",
    d: "M0,0H16.2V16.2H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2597",
    "data-name": "Path 2597",
    d: "M9.1,12.407V13.8h3.374v1.35h-8.1V13.8H7.749V12.407A5.4,5.4,0,0,1,3.025,7.049V3h10.8V7.049A5.4,5.4,0,0,1,9.1,12.407ZM1,4.35H2.35v2.7H1Zm13.5,0h1.35v2.7H14.5Z",
    transform: "translate(-0.325 -0.975)",
    fill: "#ffb400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/badge.55695909a0fef45fe79b6fb9ecd389e1.svg";
export { ForwardRef as ReactComponent };